import * as React from "react";
// UI Framework
import { Form, Input as AntdInput } from "antd";
import { FormComponentProps } from "antd/lib/form";
// Shared components
import Button from "components/Button";
//Local Components
import Main from "screens/Dashboard/components/Main";
// Utilities and hooks
import UserStore from "state/user";
import useUser from "hooks/useUser";
import { omit } from "lodash";
import { observer, inject } from "mobx-react";
// Styles
import styles from "./index.module.scss";

interface IProps extends FormComponentProps {
	onSubmit: () => void;
	user?: UserStore;
}

const ChangePassword: React.FC<IProps> = props => {
	const { getFieldDecorator } = props.form;
	// const user = props.user ? props.user.getUser : {};
	const { changePassword } = useUser();
	const [loading, setLoading] = React.useState(false);

	function handleSubmit(e: React.FormEvent): void {
		e.preventDefault();

		props.form.validateFields(async (err, values) => {
			if (!err) {
				try {
					setLoading(true);
					// @ts-ignore
					changePassword(omit(values, ["confirmPassword"]));
					props.onSubmit();
					props.form.resetFields(["currentPassword", "newPassword", "confirmPassword"]);
					setLoading(false);
				} catch (error) {
					setLoading(false);
				}
			}
		});
	}

	function validateToCurrentPassword(_: any, value: string, callback: any) {
		if (!value) {
			callback("لطفا رمزعبور فعلی را وارد کنید.");
		} else if (value && value.length < 6) {
			callback("رمز عبور باید حداقل از 6 حرف تشکیل شده باشد.");
		} else {
			callback();
		}
	}

	function validateToNextPassword(_: any, value: string, callback: any) {
		if (!value) {
			callback("لطفا رمزعبور جدید را وارد کنید.");
		} else if (value && value.length < 6) {
			callback("رمز عبور باید حداقل از 6 حرف تشکیل شده باشد.");
		} else if (value && value === props.form.getFieldValue("currentPassword")) {
			callback("رمز عبور جدید نباید با رمز فعلی یکسان باشد!");
		} else {
			callback();
		}
	}

	function compareToFirstPassword(_: any, value: string, callback: any) {
		if (!value) {
			callback("لطفا مجدد رمز عبور خود را وارد کنید.");
		} else if (value && value !== props.form.getFieldValue("newPassword")) {
			callback("رمزهای عبور وارد شده یکسان نمی باشند!");
		} else {
			callback();
		}
	}

	return (
		<Main title="تغییر رمز عبور">
			<div className="card">
				<div className={styles["edit-info-form"]}>
					<Form onSubmit={handleSubmit}>
						<Form.Item label="رمز عبور فعلی">
							{getFieldDecorator("currentPassword", {
								rules: [
									{
										validator: validateToCurrentPassword,
									},
								],
							})(<AntdInput.Password className={styles["register-form__password-input"]} />)}
						</Form.Item>
						<Form.Item label="رمز عبور جدید">
							{getFieldDecorator("newPassword", {
								rules: [
									{
										validator: validateToNextPassword,
									},
								],
							})(<AntdInput.Password className={styles["register-form__password-input"]} />)}
						</Form.Item>
						<Form.Item label="تکرار رمز عبور جدید">
							{getFieldDecorator("confirmPassword", {
								rules: [
									{
										validator: compareToFirstPassword,
									},
								],
							})(<AntdInput.Password className={styles["register-form__password-input"]} />)}
						</Form.Item>
						<Form.Item className="button-center">
							<Button htmlType="submit" primary loading={loading}>
								تغییر
							</Button>
						</Form.Item>
					</Form>
				</div>
			</div>
		</Main>
	);
};
export default Form.create<IProps>({})(inject("user")(observer(ChangePassword)));
